import {ACTION_TYPES} from "../../consts";
import {BETTING_PROMOTION} from "../../../apps/website/modules/betting-promotion.module/bettin-ptomotion.module.consts";
import {BettingPromotionBaseHandler} from "./betting-promotion.base.handler";

export class BettingPromotionCampaignLinkHandler extends BettingPromotionBaseHandler {
  type = ACTION_TYPES.bettingPromotionCampaignLink;

  async action(params) {
    this.model.isCampaignLink = this.isCampaignLink(params.utmId);
  }

  isCampaignLink(utmId): Boolean {
    const isCampaignLink: Boolean = utmId?.split('_').includes(BETTING_PROMOTION.UTM_MODULE_ID);

    return !!isCampaignLink
  }
}
